<template>
    <ClientGetDiv>
        <ClientGetTitleArea>
            <AccountSupervisor :size="35" :style="{ paddingTop: '4px' }" />
            <TitleText>수급자 목록</TitleText>
        </ClientGetTitleArea>

        <SearchAndStatsContainer>
            <ClientRegisterBtn @click="showRegistrationSwal">
                <Plus :size="20" :style="{ paddingTop: '4px' }" />
                수급자 등록
            </ClientRegisterBtn>

            <ClientTypeSelect v-model="selectedClientType" @change="onClientTypeChange">
                <option value="all">전체</option>
                <option value="recipients">급여</option>
                <option value="b_recipients">비급여</option>
            </ClientTypeSelect>

            <ClientGetSearchArea>
                <ClientGetSearchInputTxt v-model="searchQuery" type="text" placeholder="수급자명, 인정번호를 입력하세요"
                    @keyup.enter="fetchData" />
                <ClientGetSearchBtn @click="fetchData">
                    <Magnify />
                </ClientGetSearchBtn>
            </ClientGetSearchArea>

            <StatsBox>
                <StatItem>
                    <StatLabel>전체 수급자</StatLabel>
                    <StatValue>{{ clients_info.total_all_cnt }}</StatValue>명
                </StatItem>
                <StatItem>
                    <StatLabel>조회된 수급자</StatLabel>
                    <StatValue>{{ clients_info.total_cnt }}</StatValue>명
                </StatItem>
            </StatsBox>
        </SearchAndStatsContainer>

        <ClientGetTableContainer>
            <ClientGetTable>
                <ClientGetTableThead>
                    <ClientGetTableTr>
                        <th>수급자성함</th>
                        <th>인정번호</th>
                        <th>기관기호</th>
                        <th>대상</th>
                        <th class="address">주소</th>
                        <th>보호자성함</th>
                        <th>관계</th>
                        <th>담당자</th>
                    </ClientGetTableTr>
                </ClientGetTableThead>
                <ClientGetTableTbody>
                    <ClientGetTableTr v-for="(client, index) in pagedClients" :key="index" :class="{
                        'success': client.target === '일반',
                        'danger': client.target === '기초',
                        'info': client.target === '의료급여',
                        'warning': client.target === '감경',
                        'client_tr': true,
                    }" @click="clientDetail(client); clientModalClose()">
                        <td>{{ client.name }}</td>
                        <td>{{ client.number }}</td>
                        <td>{{ client.cnum }}</td>
                        <td>
                            <TargetBadge :target="client.target">
                                {{ client.target }}
                            </TargetBadge>
                        </td>
                        <td class="address">{{ client.address }}</td>
                        <td>{{ client.guardname }}</td>
                        <td>{{ client.guardtarget }}</td>
                        <td>{{ client.manager }}</td>
                    </ClientGetTableTr>
                </ClientGetTableTbody>
            </ClientGetTable>
        </ClientGetTableContainer>

        <!-- !페이지네이션 -->
        <PaginationContainer v-if="totalPages > 1">
            <Pagination>
                <PaginationButton @click="changePage(1)" :disabled="currentPage === 1">
                    <ChevronDoubleLeft :size="20" :style="{ paddingTop: '2px' }" />
                </PaginationButton>
                <PaginationButton @click="changePage(currentPage - 1)" :disabled="currentPage === 1">
                    <ChevronLeft :size="20" :style="{ paddingTop: '2px' }" />
                </PaginationButton>

                <PaginationNumber v-for="page in visiblePages" :key="page" :active="page === currentPage"
                    @click="changePage(page)">
                    {{ page }}
                </PaginationNumber>

                <PaginationButton @click="changePage(currentPage + 1)" :disabled="currentPage === totalPages">
                    <ChevronRight :size="20" :style="{ paddingTop: '2px' }" />
                </PaginationButton>
                <PaginationButton @click="changePage(totalPages)" :disabled="currentPage === totalPages">
                    <ChevronDoubleRight :size="20" :style="{ paddingTop: '2px' }" />
                </PaginationButton>
            </Pagination>
        </PaginationContainer>
    </ClientGetDiv>
</template>

<script>
import * as injectGlobal from '@/assets/styles/global/public.js';
import * as ClientGetCss from '@/assets/styles/order/modal/ClientGetModalCss.js';

import AccountSupervisor from 'vue-material-design-icons/AccountSupervisor.vue';
import Magnify from 'vue-material-design-icons/Magnify.vue';
import Plus from 'vue-material-design-icons/Plus.vue';
import ChevronDoubleLeft from 'vue-material-design-icons/ChevronDoubleLeft.vue';
import ChevronDoubleRight from 'vue-material-design-icons/ChevronDoubleRight.vue';
import ChevronLeft from 'vue-material-design-icons/ChevronLeft.vue';
import ChevronRight from 'vue-material-design-icons/ChevronRight.vue';

export default {
    components: {
        ...injectGlobal,
        ...ClientGetCss,
        AccountSupervisor,
        Magnify,
        Plus,
        ChevronDoubleLeft,
        ChevronDoubleRight,
        ChevronLeft,
        ChevronRight,
    },

    emits: ['clientDetail', 'close'],

    data() {
        return {
            clients_info: {
                clients: [],
                total_cnt: 0,
                total_all_cnt: 0,
            },
            searchQuery: '',
            currentPage: 1,
            perPage: 10,
            totalPages: 1,
            selectedClientType: 'all',
        };
    },

    computed: {
        isTestUser() {
            try {
                const userInfo = JSON.parse(localStorage.getItem('userInfo'));
                return userInfo && userInfo.id === 'test';
            } catch (error) {
                return false;
            }
        },
        pagedClients() {
            return this.clients_info.clients;
        },
        visiblePages() {
            const pages = [];
            const maxVisiblePages = 10; // 최대 10개 페이지 표시

            // 현재 페이지가 10 이하인 경우
            if (this.totalPages <= maxVisiblePages) {
                // 전체 페이지를 모두 표시
                for (let i = 1; i <= this.totalPages; i++) {
                    pages.push(i);
                }
            } else {
                // 현재 페이지가 10 이하인 경우: 1~10 표시
                if (this.currentPage <= 10) {
                    for (let i = 1; i <= 10; i++) {
                        pages.push(i);
                    }
                }
                // 현재 페이지가 10을 넘은 경우: 10개씩 그룹으로 이동
                else {
                    const groupStart = Math.floor((this.currentPage - 1) / 10) * 10 + 1;
                    const groupEnd = Math.min(groupStart + 9, this.totalPages);

                    for (let i = groupStart; i <= groupEnd; i++) {
                        pages.push(i);
                    }
                }
            }

            return pages;
        },
    },

    methods: {
        // =========================================
        // 수급자, 비급여자 등록 모달 관련 코드
        // =========================================
        openRegistrationModal() {
            this.showRegistrationModal = true;
            this.showRegistrationSwal();
        },

        // 청구자 등록
        async showRegistrationSwal() {
            try {
                const { value: formValues } = await this.$swal.fire({
                    title: '고객 등록',
                    html: this.getRegistrationFormHTML(),
                    focusConfirm: false,
                    showCancelButton: true,
                    confirmButtonText: '등록',
                    cancelButtonText: '취소',
                    width: '600px',
                    preConfirm: () => {
                        return this.validateRegistrationForm();
                    },
                    didOpen: () => {
                        this.initializeAddressSearch();
                    }
                });

                if (formValues) {
                    await this.registerRecipients(formValues);
                }
            } catch (error) {
                console.error('고객 등록 모달 오류:', error);
                this.$swal.fire({
                    title: '오류 발생',
                    text: '고객 등록 중 오류가 발생했습니다.',
                    icon: 'error',
                    confirmButtonText: '확인'
                });
            }
        },

        getRegistrationFormHTML() {
            return `
                <div class="registration-form">
                    <style>
                        .registration-form {
                            max-height: 500px;
                            overflow-y: auto;
                            padding: 0;
                        }
                        
                        .form-row {
                            display: flex;
                            gap: 16px;
                            margin-bottom: 20px;
                        }
                        
                        .form-group {
                            flex: 1;
                            display: flex;
                            flex-direction: column;
                        }
                        
                        .form-group.full-width {
                            flex: none;
                            width: 100%;
                        }
                        
                        .form-group label {
                            font-size: 15px;
                            font-weight: 600;
                            color: #374151;
                            margin-bottom: 6px;
                            display: block;
                        }
                        
                        .form-group input,
                        .form-group select {
                            padding: 12px 16px;
                            border: 2px solid #e5e7eb;
                            border-radius: 12px;
                            font-size: 14px;
                            transition: all 0.2s ease;
                            background: #ffffff;
                            color: #1f2937;
                        }
                        
                        .form-group input:focus,
                        .form-group select:focus {
                            outline: none;
                            border-color: #0f4c5c;
                        }
                        
                        .form-group input::placeholder {
                            color: #9ca3af;
                        }
                        
                        .address-input-group {
                            display: flex;
                            gap: 8px;
                            align-items: center;
                        }
                        
                        .address-input-group input {
                            flex: 1;
                        }
                        
                        .address-search-btn {
                            padding: 12px 20px;
                            background: linear-gradient(135deg, #0f4c5c 0%, #1a6b7a 100%);
                            color: white;
                            border: none;
                            border-radius: 12px;
                            font-size: 13px;
                            font-weight: 600;
                            cursor: pointer;
                            transition: all 0.3s ease;
                            white-space: nowrap;
                            box-shadow: 0 4px 15px rgba(15, 76, 92, 0.2);
                            position: relative;
                            overflow: hidden;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            gap: 8px;
                            min-width: 120px;
                        }
                        
                        .address-search-btn::before {
                            content: '';
                            position: absolute;
                            top: 0;
                            left: -100%;
                            width: 100%;
                            height: 100%;
                            background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
                            transition: left 0.5s;
                        }
                        
                        .address-search-btn:hover {
                            background: linear-gradient(135deg, #1a6b7a 0%, #0f4c5c 100%);
                            transform: translateY(-2px);
                            box-shadow: 0 6px 20px rgba(15, 76, 92, 0.3);
                        }
                        
                        .address-search-btn:hover::before {
                            left: 100%;
                        }
                        
                        .address-search-btn:active {
                            transform: translateY(0);
                            box-shadow: 0 2px 10px rgba(15, 76, 92, 0.2);
                        }
                        
                        .address-search-btn:focus {
                            outline: none;
                            box-shadow: 0 0 0 3px rgba(15, 76, 92, 0.1), 0 4px 15px rgba(15, 76, 92, 0.2);
                        }
                        
                        .address-search-btn .search-icon {
                            width: 16px;
                            height: 16px;
                            fill: currentColor;
                        }
                        
                        .form-group input[readonly] {
                            background: #f9fafb;
                            color: #6b7280;
                            cursor: pointer;
                        }
                        
                        .form-group input[readonly]:hover {
                            background: #f3f4f6;
                        }
                        
                        /* 스크롤바 스타일링 */
                        .registration-form::-webkit-scrollbar {
                            width: 6px;
                        }
                        
                        .registration-form::-webkit-scrollbar-track {
                            background: #f1f5f9;
                            border-radius: 3px;
                        }
                        
                        .registration-form::-webkit-scrollbar-thumb {
                            background: #cbd5e1;
                            border-radius: 3px;
                        }
                        
                        .registration-form::-webkit-scrollbar-thumb:hover {
                            background: #94a3b8;
                        }
                    </style>
                    
                    <div class="form-row">
                        <div class="form-group">
                            <label for="beneficiaryName">고객명</label>
                            <input type="text" id="beneficiaryName" placeholder="고객명을 입력하세요">
                        </div>
                        <div class="form-group">
                            <label for="recognitionNumber">인정번호</label>
                            <input type="text" id="recognitionNumber" placeholder="인정번호를 입력하세요">
                        </div>
                    </div>
                    
                    <div class="form-row">
                        <div class="form-group">
                            <label for="institutionCode">기관기호</label>
                            <input type="text" id="institutionCode" placeholder="기관기호를 입력하세요">
                        </div>
                        <div class="form-group">
                            <label for="benefitType">구분</label>
                            <select id="benefitType">
                                <option value="">구분을 선택하세요</option>
                                <option value="일반">일반</option>
                                <option value="기초">기초</option>
                                <option value="감경">감경</option>
                                <option value="의료급여">의료급여</option>
                            </select>
                        </div>
                    </div>
                    
                    <div class="form-row">
                        <div class="form-group full-width">
                            <label for="address">주소</label>
                            <div class="address-input-group">
                                <input type="text" id="address" placeholder="주소를 입력하세요" readonly>
                                <button type="button" id="addressSearchBtn" class="address-search-btn">
                                    주소 검색
                                </button>
                            </div>
                            <input type="text" id="address_detail" placeholder="상세주소를 입력하세요" style="margin-top: 8px;">
                        </div>
                    </div>
                    
                    <div class="form-row">
                        <div class="form-group">
                            <label for="guardianName">보호자명</label>
                            <input type="text" id="guardianName" placeholder="보호자명을 입력하세요">
                        </div>
                        <div class="form-group">
                            <label for="guardianRelation">보호자 관계</label>
                            <select id="guardianRelation">
                                <option value="">관계를 선택하세요</option>
                                <option value="본인">본인</option>
                                <option value="배우자">배우자</option>
                                <option value="자녀">자녀</option>
                                <option value="부모">부모</option>
                                <option value="기타">기타</option>
                            </select>
                        </div>
                    </div>
                    
                    <div class="form-row">
                        <div class="form-group">
                            <label for="manager">담당자</label>
                            <input type="text" id="manager" placeholder="담당자를 입력하세요">
                        </div>
                        <div class="form-group">
                            <label for="phone">연락처</label>
                            <input type="tel" id="phone" placeholder="연락처를 입력하세요">
                        </div>
                    </div>
                </div>
            `;
        },

        validateRegistrationForm() {
            const name = document.getElementById('beneficiaryName').value.trim();
            const target = document.getElementById('benefitType').value;
            const address = document.getElementById('address').value.trim();
            const manager = document.getElementById('manager').value.trim();

            if (!name) {
                this.$swal.showValidationMessage('고객명을 입력해주세요.');
                return false;
            }

            if (!target) {
                this.$swal.showValidationMessage('구분을 선택해주세요.');
                return false;
            }

            if (!address) {
                this.$swal.showValidationMessage('주소를 입력해주세요.');
                return false;
            }

            if (!manager) {
                this.$swal.showValidationMessage('담당자를 입력해주세요.');
                return false;
            }

            return {
                name,
                target,
                address,
                manager
            };
        },

        async registerRecipients(formValues) {
            let recipientData;

            try {
                // 폼 데이터 수집
                recipientData = {
                    name: document.getElementById('beneficiaryName').value.trim(),
                    number: document.getElementById('recognitionNumber').value.trim() || null,
                    cnum: document.getElementById('institutionCode').value.trim() || null,
                    target: document.getElementById('benefitType').value || null,
                    address: document.getElementById('address').value.trim() || null,
                    address_detail: document.getElementById('address_detail').value.trim() || null,
                    guard_name: document.getElementById('guardianName').value.trim() || null,
                    guard_target: document.getElementById('guardianRelation').value || null,
                    manager: document.getElementById('manager').value.trim() || null,
                    phone: document.getElementById('phone').value.trim() || null,
                    type: '비급여',
                    companykey: this.$globalState.company_key
                };
                // 백엔드 API 호출
                const response = await this.$axios({
                    method: 'post',
                    url: `${this.$apiUrls.hanqmedi}/registerRecipient`,
                    data: recipientData,
                    headers: {
                        'Authorization': `Bearer ${localStorage.getItem('token')}`,
                        'Content-Type': 'application/json'
                    }
                });

                if (response.data && response.data.success) {
                    // 성공 메시지
                    await this.$swal.fire({
                        title: '등록 완료',
                        text: `"${recipientData.name}"고객이 성공적으로 등록되었습니다.`,
                        icon: 'success',
                        confirmButtonText: '확인'
                    });

                    // 모달 닫기
                    this.showRegistrationModal = false;

                    // 데이터 새로고침
                    await this.fetchData();
                } else {
                    // 백엔드에서 성공하지 않은 경우
                    throw new Error(response.data?.message || '고객 등록에 실패했습니다.');
                }

            } catch (error) {
                console.error('고객 등록 오류:', {
                    error: {
                        message: error.message,
                        response: error.response?.data,
                        status: error.response?.status
                    },
                    timestamp: new Date().toISOString(),
                    recipientData: recipientData || 'undefined'
                });

                let errorMessage = '고객 등록 중 오류가 발생했습니다.';
                let errorTitle = '등록 실패';

                // 구체적인 에러 메시지 처리
                if (error.response?.data?.message) {
                    errorMessage = error.response.data.message;
                } else if (error.message) {
                    errorMessage = error.message;
                }

                // HTTP 상태 코드에 따른 에러 제목 설정
                if (error.response?.status === 400) {
                    errorTitle = '입력 오류';
                } else if (error.response?.status === 401) {
                    errorTitle = '인증 오류';
                } else if (error.response?.status === 500) {
                    errorTitle = '서버 오류';
                }

                // 실패 메시지 표시
                this.$swal.fire({
                    title: errorTitle,
                    text: errorMessage,
                    icon: 'error',
                    confirmButtonText: '확인',
                    showCloseButton: true
                });
            }
        },

        // 급여/비급여 선택 변경 시 호출되는 메서드
        onClientTypeChange() {
            this.currentPage = 1; // 페이지 초기화
            this.searchQuery = ''; // 검색어 초기화
            this.fetchData();
        },

        async fetchData() {
            try {
                if (!this.$globalState.company_key) {
                    const userInfo = localStorage.getItem('userInfo');
                    if (userInfo) {
                        const parsedInfo = JSON.parse(userInfo);
                        this.$setGlobalState('id', parsedInfo.id);
                        this.$setGlobalState('manager_name', parsedInfo.name);
                        this.$setGlobalState('company_name', parsedInfo.company);
                        this.$setGlobalState('company_key', parsedInfo.company_key);
                    } else {
                        this.$swal.fire('인증 오류', '로그인이 필요합니다.', 'error');
                        this.$router.push('/login');
                        return;
                    }
                }

                // 백엔드 API를 통해 수급자 정보 조회 (절대 경로 사용)
                const apiUrl = `${this.$apiUrls.hanqmedi}/getClients/${this.$globalState.company_key}`;

                // 선택된 수급자 타입에 따른 파라미터 설정
                let typeParam = '';
                if (this.selectedClientType === 'recipients') {
                    typeParam = '급여';
                } else if (this.selectedClientType === 'b_recipients') {
                    typeParam = '비급여';
                }
                // 'all'인 경우 typeParam은 빈 문자열로 유지

                const response = await this.$axios({
                    method: 'get',
                    url: apiUrl,
                    params: {
                        limit: this.perPage,
                        page: this.currentPage,
                        search: this.searchQuery,
                        type: typeParam
                    },
                    headers: {
                        'Authorization': `Bearer ${localStorage.getItem('token')}`
                    }
                });

                // API 응답 구조에 맞게 수정
                if (response.data && response.data.recipients && Array.isArray(response.data.recipients)) {
                    // API 응답 데이터를 프론트엔드에서 사용하는 형태로 매핑
                    this.clients_info.clients = response.data.recipients.map(client => ({
                        name: client.name || '', // 수급자성함
                        number: client.number || '', // 인정번호
                        cnum: client.cnum || '', // 기관기호
                        target: client.target || '', // 대상
                        address: client.address || '', // 주소
                        guardname: client.guard_name || '', // 보호자성함
                        guardtarget: client.guard_target || '', // 관계
                        manager: client.manager || '', // 담당자
                        phone1: client.phone1 || '', // 전화번호1
                        phone2: client.phone2 || '', // 전화번호2
                        // 추가 필드들도 매핑
                        id: client.id,
                        company_id: client.company_id, // 회사ID
                        user_id: client.user_id, // 사용자ID
                        address2: client.address2 || '', // 주소2
                        address_detail: client.address_detail || '', // 주소상세
                        address_num: client.address_num || '', // 주소번호
                        bank_accout: client.bank_accout || '', // 계좌번호
                        bank_admin: client.bank_admin || '', // 계좌주
                        bank_name: client.bank_name || '', // 은행명
                        bank_phone: client.bank_phone || '', // 은행전화번호
                        bank_resident: client.bank_resident || '', // 은행주소
                        center_name: client.center_name || '', // 센터명
                        cnum: client.cnum || '', // 센터번호
                        gender: client.gender || '', // 성별
                        guard_resident: client.guard_resident || '', // 보호자생년월일
                        memo: client.memo || '', // 메모
                        msgno: client.msgno || '', // 메시지번호
                        ranker: client.ranker || '', // 순위
                        rcgt: client.rcgt || '', // 주소
                        sale: client.sale || 0, // 판매
                        // 수급자 타입 정보 추가
                        type: client.type || '급여',
                        source: client.source || 'unknown',
                        isNonBenefit: client.isNonBenefit || false
                    }));

                    // 페이지네이션 정보 업데이트
                    this.clients_info.total_cnt = response.data.total_count || 0;
                    this.clients_info.total_all_cnt = response.data.total_count || 0;

                    // 전체 페이지 수 계산 (data property로 직접 수정)
                    this.totalPages = response.data.total_page || 1;

                    if (this.searchQuery && this.clients_info.total_cnt === 0) {
                        this.$swal.fire('검색 결과 없음', `${this.searchQuery} 검색 결과가 없습니다.`, 'info');
                    }
                } else {
                    this.clients_info.clients = [];
                    this.clients_info.total_cnt = 0;
                    this.clients_info.total_all_cnt = 0;
                    this.totalPages = 1; // data property로 직접 수정
                    if (this.searchQuery) {
                        this.$swal.fire('검색 결과 없음', `${this.searchQuery} 검색 결과가 없습니다.`, 'info');
                    }
                }
            } catch (error) {
                console.error('데이터를 가져오는 중 오류 발생:', error);
                this.$swal.fire('오류', '데이터를 불러오는데 실패했습니다.', 'error');
                this.clients_info.clients = [];
                this.clients_info.total_cnt = 0;
                this.clients_info.total_all_cnt = 0;
                this.totalPages = 1; // data property로 직접 수정
            }
        },

        changePage(page) {
            if (page !== this.currentPage && page > 0 && page <= this.totalPages) {
                this.currentPage = page;
                this.$nextTick(() => {
                    this.fetchData();
                });
            }
        },

        clientDetail(client) {
            const modifiedClient = { ...client };
            if (modifiedClient.phone1 === modifiedClient.phone2) {
                modifiedClient.phone2 = '';
            }
            this.$emit('clientDetail', modifiedClient);
            this.$swal.fire({
                title: '수급자 선택 완료',
                text: '수급자 정보가 성공적으로 선택되었습니다.',
                icon: 'success',
                showConfirmButton: false,
                timer: 1200
            });
        },

        clientModalClose() {
            this.$emit('close');
        },

        initializeAddressSearch() {
            const addressSearchBtn = document.getElementById('addressSearchBtn');
            if (addressSearchBtn) {
                addressSearchBtn.addEventListener('click', () => {
                    this.searchAddress();
                });
            }
        },

        searchAddress() {
            new window.daum.Postcode({
                oncomplete: (data) => {
                    document.getElementById('address').value = data.address;
                    document.getElementById('address_detail').focus();
                }
            }).open();
        },

        handleEscKey(event) {
            if (event.key === 'Escape') {
                event.preventDefault();
                event.stopPropagation();
                this.$emit('close');
            }
        }
    },

    created() {
        document.addEventListener('keydown', this.handleEscKey);
    },

    beforeUnmount() {
        document.removeEventListener('keydown', this.handleEscKey);
    },

    mounted() {
        this.fetchData();
    },

    watch: {
        totalPages(newVal) {
            if (this.currentPage > newVal) {
                this.currentPage = Math.max(1, newVal);
            }
        },
    },
};
</script>

<style scoped>
/* 블러 효과를 위한 추가 스타일 */
.blurred {
    filter: blur(4px) !important;
    pointer-events: auto;
    user-select: auto;
    -webkit-user-select: auto;
    -moz-user-select: auto;
    -ms-user-select: auto;
}

/* 블러된 요소 내부의 상호작용은 유지 (클릭 가능) */
.blurred * {
    pointer-events: auto;
    user-select: auto;
    -webkit-user-select: auto;
    -moz-user-select: auto;
    -ms-user-select: auto;
}

/* 테이블 셀 내용 블러 처리 */
.blurred td {
    filter: blur(4px) !important;
}
</style>